import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const Calendar = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="30" viewBox="0 0 28 30">
      <g id="calendar" transform="translate(0.251 -0.166)">
        <rect id="Rectangle_1480" data-name="Rectangle 1480" width="26" height="25" rx="2" transform="translate(0.749 4.166)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        <line id="Ligne_8" data-name="Ligne 8" y2="6" transform="translate(19.749 1.166)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        <line id="Ligne_9" data-name="Ligne 9" y2="6" transform="translate(7.749 1.166)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
        <line id="Ligne_10" data-name="Ligne 10" x2="26" transform="translate(0.749 12.166)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
      </g>
    </svg>
  </SvgIcon>
);

export default Calendar;